import type { PluginDefaultTranslationsObject } from '../types.js'

export const tr: PluginDefaultTranslationsObject = {
  '@seshuk/payload-storage-bunny': {
    // TUS Upload
    tusUploadChecking: 'Önceki yüklemeler kontrol ediliyor...',
    tusUploadDisableMode: 'TUS modunu devre dışı bırak',
    tusUploadEnableMode: 'TUS modunu etkinleştir',
    tusUploadErrorFileType: 'Dosya türüne izin verilmiyor',
    tusUploadErrorInitUpload: 'Yükleme başlatılamadı',
    tusUploadErrorPrevCheckFail: 'Önceki yüklemeler kontrol edilemedi',
    tusUploadErrorRestoreUpload: 'Yükleme geri yüklenemedi',
    tusUploadFileSize: '{{size}} MB',
    tusUploadFinalizing: 'Tamamlanıyor...',
    tusUploadPause: 'Duraklat',
    tusUploadPreparing: 'Yükleme hazırlanıyor...',
    tusUploadResume: 'Devam et',
    tusUploadRetry: 'Tekrar dene',
    tusUploadStartOver: 'Baştan başla',
    tusUploadStartUpload: 'Yüklemeyi başlat',
    tusUploadStatusChecking: 'Önceki yüklemeler kontrol ediliyor...',
    tusUploadStatusCompleted: 'Yükleme başarıyla tamamlandı!',
    tusUploadStatusFinalizing: 'Yükleme tamamlanıyor...',
    tusUploadStatusIdle: 'Yükleme için hazır',
    tusUploadStatusIdleWithRestore: 'Devam etmeye veya baştan başlamaya hazır',
    tusUploadStatusPaused: 'Yükleme %{{progress}} oranında duraklatıldı',
    tusUploadStatusUploading: 'Yükleniyor... %{{progress}}',
    tusUploadTimeHours: 's',
    tusUploadTimeMinutes: 'd',
    tusUploadTimeSeconds: 's',

    // Error messages
    errorAccessDenied: 'Bu kaynağa erişim izniniz yok',
    errorDeleteFileFailed: 'Dosya silinemedi: {{filename}}',
    errorMissingRequiredFields: 'Bazı gerekli bilgiler eksik',
    errorNoServiceConfigured: 'Hiçbir hizmet yapılandırılmamış',
    errorStreamConfigMissing: 'Bunny Stream düzgün yapılandırılmamış',
    errorTitleRequired: 'Lütfen videonuz için bir başlık girin',
    errorUploadFileFailed: 'Dosya yüklenemedi: {{filename}}',
  },
}
